import React from 'react';
// import initializeI18n from './translations/translator';

// initializeI18n();

const AppContainer = (props) => {
  return <div className='app-container'>{props.children}</div>;
};

export default AppContainer;
